import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { Link } from "react-router-dom";

import WishlistSingle from "./WishlistSingle";

const wishlistText = {
  title: "Листа на желби",
  intro:
    "Сочувајте ги омилените модели, споредувајте ги подоцна и со еден клик префрлете ги во кошничка.",
  savedProducts: "сочувани производи",
  oneClick: "1 клик",
  addToCart: "до додавање во кошничка",
  buzzPicks: "брзо враќање до омилените фаворити",
  emptyTitle: "Вашата листа на желби е празна",
  emptyText:
    "Кога ќе видите нешто што ви се допаѓа, додадете го во листата и вратете се кога сакате.",
  continueShopping: "Продолжи со купување",
};

function Wishlist() {
  const wishlistproducts = useSelector((state) => state.wishlist);

  useEffect(() => {
    document.title = "Wishlist | Buzz Mobile";
  }, []);

  return (
    <div className="wishlist-page container">
      <div className="wishlist-page__hero">
        <div className="wishlist-page__intro">
          <span className="cart-page__eyebrow">Омилени</span>
          <h1>{wishlistText.title}</h1>
          <p>{wishlistText.intro}</p>
        </div>
      </div>

      {wishlistproducts.length > 0 ? (
        <div className="wishlist-page__grid">
          {wishlistproducts.map((wish, index) => (
            <WishlistSingle product={wish} key={index} />
          ))}
        </div>
      ) : (
        <div className="cart-page__empty wishlist-page__empty">
          <Alert severity="error">{wishlistText.emptyTitle}</Alert>
          <p>{wishlistText.emptyText}</p>
          <div className="continue__shopping wishlist">
            <Link to="/">{wishlistText.continueShopping}</Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default Wishlist;
